import { defineStore } from 'pinia'

const LSKEY_GDPR_CONFIRMED = 'jps-gdpr-confirmed'
const LSKEY_GDPR_ACCEPT_TRACKING = 'jps-gdpr-accept-tracking'

export const usePrivacyStore = defineStore(
  'privacy',
  () => {

    const _gdprAcceptTracking: Ref<boolean> = ref(lsGet(LSKEY_GDPR_ACCEPT_TRACKING, false))
    const gdprAcceptTracking = computed({
      get: () => _gdprAcceptTracking.value,
      set: v => {
        lsSet(LSKEY_GDPR_ACCEPT_TRACKING, v)
        _gdprAcceptTracking.value = v
      },
    })

    const _gdprConfirmed: Ref<boolean> = ref(lsGet(LSKEY_GDPR_CONFIRMED, false))
    const gdprConfirmed = computed({
      get: () => _gdprConfirmed.value,
      set: v => {
        lsSet(LSKEY_GDPR_CONFIRMED, v)
        _gdprConfirmed.value = v
      },
    })

    const _showPrivacyModal: Ref<boolean> = ref(false)
    const def = gdprConfirmed.value
    if (!def) {
      _showPrivacyModal.value = true
    }

    const showPrivacyModal = computed({
      get: () => _showPrivacyModal.value,
      set: v => _showPrivacyModal.value = v,
    })

    return {
      gdprAcceptTracking,
      gdprConfirmed,
      showPrivacyModal,
    }
  },
  { persist: false },
)
